import { Object3D } from "three";
import { BaseVisual } from "./BaseVisual";
import * as THREE from "three";
import { Visual } from "../models/Visual";
import { Vec3 } from "../models/SyntheticMap";

export enum LightType {
  Point = 'point',
  Directional = 'directional',
  // Spot = 'spot',
  // Ambient = 'ambient',
}

export interface LightVisualData extends Visual {
  lightType: LightType;
  intensity: number;
  target: Vec3;
}

export class LightVisual extends BaseVisual implements LightVisualData {
  lightType: LightType = LightType.Point; // Default light type
  intensity: number = 1.0; // Default intensity
  target = { x: 0, y: 0, z: 0 }; // Default target position
  color = 0xffffff; // Default color (white)
  private lightContainer = new THREE.Group();
  
  public getType(): string {
    return 'LightVisual';
  }
  
  protected async buildObj(): Promise<Object3D> {
    this.updateObj(); // Initialize the light object
    return this.lightContainer;
  }

  public getFrindlyName(): string {
    return this.id || `Light: ${this.lightType}`;
  }

  public updateObj(): void {
    // debugger;
    this.lightContainer.position.set(this.position.x, this.position.y, this.position.z);
    this.lightContainer.rotation.set(this.rotation.x, this.rotation.y, this.rotation.z);
    this.lightContainer.getObjectByName('LightVisual')?.removeFromParent(); // Remove existing light if it exists
    this.lightContainer.getObjectByName('LightHelper')?.removeFromParent(); // Remove existing helper if it exists
    // Create or update the light
    let light: THREE.Light;
    switch (this.lightType) {
      case LightType.Point:
        light = new THREE.PointLight(this.color, this.intensity);
        break;
      case LightType.Directional:
        const dl = new THREE.DirectionalLight(this.color, this.intensity);
        const activeSite = this.wr.dataService.activeSite;
        if (activeSite) {
          dl.target = activeSite.obj; // Set the target to the site anchor
        } else {
          dl.target = this.wr.planetService.worldGroup; // Default target
        }
        light = dl;
        // const dlHelper = new THREE.DirectionalLightHelper(dl, 5);
        // dlHelper.name = 'LightHelper';
        // this.lightContainer.add(dlHelper);
        break;
      // case LightType.Spot:
      //   light = new THREE.SpotLight(this.color, this.intensity);
      //   light.lookAt(new THREE.Vector3(this.target.x, this.target.y, this.target.z));
      //   const spotHelper = new THREE.SpotLightHelper(light);
      //   spotHelper.name = 'LightHelper';
      //   this.lightContainer.add(spotHelper); // Add helper for spot light
      //   break;
      // case LightType.Ambient:
      //   light = new THREE.AmbientLight(this.color, this.intensity);
      //   break;
      default:
        throw new Error(`Unknown light type: ${this.lightType}`);
    }
    light.name = 'LightVisual';
    // Add the new light
    this.lightContainer.add(light);
  }

  public createDataTemplate(): Visual {
    const data: LightVisualData = {
      type: this.getType(),
      _id: this._id,
      id: this.id,
      position: this.position,
      rotation: this.rotation,
      orgId: this.orgId,
      siteAnchorId: this.siteAnchorId,
      lightType: this.lightType,
      intensity: this.intensity,
      target: this.target,
      location: this.location,
    };
    return data;
  }
}

